import { ref } from 'vue'
import { useMainStore } from '@/stores/main'
import * as Server from '@/services/Server'
import * as Auth from '@/services/Auth'

/**
 * Reading a news: the dialog shows one at a time, and the server is told the account opened it.
 *
 * A visitor reads without an account, so nothing is sent and nothing is remembered — their count is
 * always zero (it is a fact of the account, see doc/news.md). `onRead` lets a list update its unread
 * badge without asking the server again.
 */
export function useNewsReader(onRead) {
  const store = useMainStore()
  const selected = ref(null)

  function open(news) {
    selected.value = news

    if (news.read) {
      return
    }

    news.read = true
    onRead?.(news)

    if (Auth.isAuthenticated()) {
      // Fire and forget: a lost acknowledgement only means the news comes back as unread.
      Server.put(store.apiPath.news_read(news.id)).catch(() => {})
    }
  }

  function close() {
    selected.value = null
  }

  return { selected, open, close }
}
